import { render, staticRenderFns } from "./laborScreen.vue?vue&type=template&id=03a2240a&scoped=true"
import script from "./laborScreen.vue?vue&type=script&lang=js"
export * from "./laborScreen.vue?vue&type=script&lang=js"
import style0 from "./laborScreen.vue?vue&type=style&index=0&id=03a2240a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a2240a",
  null
  
)

export default component.exports